import LightlyActive from "./Icons/LightlyActive"
import ActiveIcon from "./Icons/ActiveIcon"
import VeryActive from "./Icons/VeryActive"
import OnboardingOptions, {
  IOnboardingOption,
} from "components/onboarding/OnboardingOptions"
import { Title24 } from "components/Typo"
import { TitleBox } from "features/onboarding/PersonalInfo/styled"
import { IActivityLevel } from "features/onboarding/types"

const options: IOnboardingOption[] = [
  {
    label: "Lightly Active",
    description: "Sedentary lifestyle",
    value: "LIGHTLY_ACTIVE",
    Icon: LightlyActive,
  },
  {
    label: "Active",
    description: "Occasionally active",
    value: "ACTIVE",
    Icon: ActiveIcon,
  },
  {
    label: "Very Active",
    description: "Exercise almost every day",
    value: "VERY_ACTIVE",
    Icon: VeryActive,
  },
]

const SetActivityLevel = ({
  value,
  onChange,
}: {
  value: IActivityLevel
  onChange: (value: IActivityLevel) => void
}) => {
  return (
    <div>
      <TitleBox>
        <Title24>What is your current level of activity?</Title24>
      </TitleBox>

      <OnboardingOptions
        options={options}
        onChange={(val) => onChange(val as IActivityLevel)}
        value={value}
      />
    </div>
  )
}

export default SetActivityLevel
